import type { OpeningHoursCommand } from '@zoomit/editor';
import { Sheet } from '@zoomit/mobile-sheet';
import { Box, Modal } from '@zoomit/primitives';
import { isMobile } from '@zoomit/web-kit';
import { Button, cssVar, ModalActions, ModalHead, theme, Typography } from '@zoomit/zoomit-ds';

import { getWorkingHours } from '../../../helpers/attraction/parseWorkingHours';

export type Props = {
  data: OpeningHoursCommand;
  isOpen: boolean;
  onClose: () => void;
};
export function AttractionWorkingHoursPopover(props: Props) {
  if (!props.isOpen && !isMobile) return <></>;
  return isMobile ? <WorkHourBottomSheet {...props} /> : <WorkHourModal {...props} />;
}

function WorkHourBottomSheet(props: Props) {
  const { data, onClose, isOpen } = props;

  return (
    <Sheet isOpen={isOpen} onClose={onClose}>
      <Sheet.Container>
        <Sheet.Header showDragHandle>
          <div className="px-6 pb-6">
            <Typography
              tag="h3"
              variant={'h5'}
              lineHeight={1.75}
              fontWeight="bold"
              className="border-r-primary1 border-r-4 border-solid pr-3"
            >
              ساعت کاری
            </Typography>
          </div>
        </Sheet.Header>
        <Sheet.Content>
          <div className="text-text min-h-72 space-y-6 px-6">
            {getWorkingHours(data.days ?? []).map(([day, workingHour]) => (
              <div key={day} className="text-body mb-3 flex items-center justify-between gap-2">
                <div>{day}</div>
                <div className="text border-grey6 dark:border-black5 border-dt grow border-b border-dotted"></div>
                <div>{workingHour}</div>
              </div>
            ))}
          </div>
        </Sheet.Content>
        <Box className="bg-background1 px-6 py-3">
          <Button variant="outline" size="full width" onClick={onClose}>
            بستن
          </Button>
        </Box>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
}

function WorkHourModal(props: Props) {
  const { data, isOpen, onClose } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHead title={'ساعت کاری'} onClose={onClose} />

      <Box
        spacing={{ pt: 'x6', pb: 'x4', px: 'x4' }}
        backgroundColor={cssVar(theme.background2)}
        className="text-text space-y-5"
      >
        {getWorkingHours(data.days ?? []).map(([day, workingHour]) => (
          <div key={day} className="text-body flex items-center justify-between gap-2" role="listitem">
            <div>{day}</div>
            <div className="text border-grey6 dark:border-black5 border-dt grow border-b border-dotted"></div>
            <div>{workingHour}</div>
          </div>
        ))}
      </Box>
      <ModalActions>
        <Button variant="outline" size="full width" className="!bg-background2" onClick={onClose}>
          بستن
        </Button>
      </ModalActions>
    </Modal>
  );
}
